import  PartnersList from './PartnersList';
export default PartnersList
